import React, {PureComponent} from 'react';

// import {Elements} from '@stripe/react-stripe-js';
// import {loadStripe} from '@stripe/stripe-js';
import CardSetupForm from './CardSetupForm';

// const stripePromise = loadStripe(process.env.REACT_APP_STRIPE);

class AddFundsStep3 extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {

    }


    render() {
        return (
            <div className='add-funds-content-container'>
                <div className='white-wrapper'>
                    <h2>Confirm Your Order</h2>
                    {/*<Elements stripe={stripePromise}>*/}
                    <CardSetupForm
                        user={this.props.user}
                        billingDetails={this.props.billingDetails}
                        stripePlanId={this.props.stripePlanId || false}
                        history={this.props.history}
                        updateUserFromServer={this.props.updateUserFromServer}
                        fundsAmount={this.props.fundsAmount}
                        addedNumbers={this.props.addedNumbers}
                        freeTrial={this.props.freeTrial}
                        updateUpcomingSwitchPlans={this.props.updateUpcomingSwitchPlans}
                        topUpViber={this.props.topUpViber}
                        viberPlan={this.props.viberPlan}
                    />
                    {/*</Elements>*/}
                    {/*<button disabled='true'>Pay with Card</button>*/}
                </div>
            </div>
        )
    }
}

export default AddFundsStep3;